<template>
  <div>
    <div class="row myrow content-mb-42" v-if="$parent.$parent.rerender">
      <div
        class="col-xs-12 mycol"
        v-bind:class="{
          'has-error': $parent.$parent.checkErrorField(
            'PROJECTS',
            'LOGIC',
            'UF_ACTUAL_TECH_ID'
          )
        }"
      >
        <tags-input
          element-id="tags"
          v-model="selectedTags"
          :existing-tags="tags"
          :only-existing-tags="true"
          @tag-added="onTagAdded"
          @tag-removed="onTagRemoved"
          @tags-updated="
            $parent.$parent.removeError(
              'PROJECTS',
              'LOGIC',
              'UF_ACTUAL_TECH_ID'
            )
          "
          placeholder="Добавить объект"
          :typeahead="true"
          :disabled="$parent.$parent.projectDisabled"
        ></tags-input>
        <div class="error-text">
          {{
            $parent.$parent.checkErrorText(
              "PROJECTS",
              "LOGIC",
              "UF_ACTUAL_TECH_ID"
            )
          }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { FETCH_DIRECTORY } from "@/store/actions.type";

export default {
  name: "ActualTechList",
  data() {
    return {
      selectedTags: [],
      tagsLoaded: false
    };
  },
  created() {
    this.$store
      .dispatch(FETCH_DIRECTORY, ["sp_list_actual_technology"])
      .then(() => {
        this.project.UF_ACTUAL_TECH_ID.forEach(function(cId) {
          this.directory.sp_list_actual_technology.forEach(function(c) {
            if (cId === c.ID) {
              this.selectedTags.push(c.NAME);
            }
          }, this);
        }, this);
        this.tagsLoaded = true;
      }, this);
  },
  methods: {
    onTagAdded(slug) {
      if (slug >= 0) {
        this.project.UF_ACTUAL_TECH_ID.push(
          this.directory.sp_list_actual_technology[parseInt(slug)].ID
        );
      }
    },
    onTagRemoved(slug) {
      let rem = 0;
      if (slug.length > 8) {
        this.directory.sp_list_actual_technology.forEach(function(c) {
          if (c.NAME === slug) {
            rem = c.ID;
          }
        });
      } else {
        let onTagRemovedName = this.directory.sp_list_actual_technology[slug]
          .NAME;
        this.directory.sp_list_actual_technology.forEach(function(c) {
          if (c.NAME === onTagRemovedName) {
            rem = c.ID;
          }
        });
      }
      if (rem > 0) {
        this.project.UF_ACTUAL_TECH_ID.forEach(function(c, index) {
          if (rem === c) {
            this.project.UF_ACTUAL_TECH_ID.splice(index, 1);
          }
        }, this);
      }
    }
  },
  computed: {
    tags() {
      let tags = {};
      this.directory.sp_list_actual_technology.forEach(function(el, k) {
        tags[k] = el.NAME;
      }, this);
      return tags;
    },

    ...mapGetters(["directory", "project"])
  }
};
</script>

<style scoped></style>
